import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7092f480"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = { class: "sidebar-nav" }
const _hoisted_4 = { class: "sidebar-links mb-1" }
const _hoisted_5 = { class: "sidebar-dropdown py-1 d-flex align-items-center position-relative" }
const _hoisted_6 = ["href", "aria-controls"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-center",
  style: {"width":"16px"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down" })
], -1))
const _hoisted_8 = { class: "m-0 ms-2 sidebar-category" }
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "nav flex-column" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar-rights d-flex flex-column pb-4" }, [
  /*#__PURE__*/_createElementVNode("small", null, "© 2025 mod-box.ru"),
  /*#__PURE__*/_createElementVNode("small", null, "All rights Reserved")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarProfileComponent = _resolveComponent("SidebarProfileComponent")!
  const _component_SidebarLinkComponent = _resolveComponent("SidebarLinkComponent")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createVNode(_component_SidebarProfileComponent),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", {
                class: "position-absolute w-100 h-100",
                style: {"right":"0"},
                "data-bs-toggle": "collapse",
                href: `#sidebarCollapse_${index}`,
                role: "button",
                "aria-expanded": "false",
                "aria-controls": `#sidebarCollapse_${index}`
              }, null, 8, _hoisted_6),
              _hoisted_7,
              _createElementVNode("a", _hoisted_8, _toDisplayString(category.title), 1)
            ]),
            _createElementVNode("div", {
              class: "collapse show",
              id: `sidebarCollapse_${index}`
            }, [
              _createElementVNode("ul", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.links, (link, linkIndex) => {
                  return (_openBlock(), _createBlock(_component_SidebarLinkComponent, {
                    key: linkIndex,
                    title: link.title,
                    obj: link.obj
                  }, null, 8, ["title", "obj"]))
                }), 128))
              ])
            ], 8, _hoisted_9)
          ]))
        }), 128))
      ]),
      _hoisted_11,
      _hoisted_12
    ])
  ]))
}